module.exports = __webpack_public_path__ + "img/tutorial_books_01.0386086f.gif";